import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
} from '@mui/material';

interface ConfirmDeleteDialogProps {
  handleClose: () => void;
  handleDelete: () => void;
  title: string;
  message: JSX.Element;
  deleteButtonText?: string;
  subText?: JSX.Element;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  handleClose,
  handleDelete,
  title,
  message,
  deleteButtonText = 'Delete',
  subText,
}) => {
  return (
    <Dialog open={true} onClose={handleClose} maxWidth='xs'>
      <DialogTitle sx={{ p: 2, textAlign: 'center' }}>{title}</DialogTitle>
      <Divider sx={{ mx: 2 }} />
      <DialogContent sx={{ textAlign: 'center', py: 5, width: 600, maxWidth: '90%', mx: 'auto' }}>
        <DialogContentText component='div'>{message}</DialogContentText>
        {subText && <DialogContentText component='div'>{subText}</DialogContentText>}
      </DialogContent>
      <Divider sx={{ mx: 2 }} />
      <DialogActions sx={{ p: 2, display: 'flex', gap: 2 }}>
        <Button variant='contained' onClick={handleDelete} fullWidth aria-label='confirm'>
          {deleteButtonText}
        </Button>
        <Button
          onClick={handleClose}
          variant='outlined'
          color='inherit'
          fullWidth
          aria-label='cancel'
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
